import React from "react"

import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"

import { CustomValidationRenderValue } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionContainer"
import {
	COMMUNICATION_WINDOW_STATE_TO_LABEL,
	CommunicationWindowState
} from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor/CommunicationWindowInput"
import { colors } from "@/styles/colors"

const CommunicationWindowContainer: CustomValidationRenderValue = {
	firstItem: {
		render: () => (
			<ContrastChip
				title="Janela de comunicação"
				backgroundColor={colors.blue[200]}
			/>
		)
	},
	comparisonItem: {
		render: () => (
			<ContrastChip
				title="está"
				backgroundColor={colors.blue[200]}
			/>
		)
	},
	secondItem: {
		render: ({ validation }) => {
			const stateLabel = COMMUNICATION_WINDOW_STATE_TO_LABEL[validation.second_param as CommunicationWindowState] ?? "??"

			return (
				<ContrastChip
					title={stateLabel}
					backgroundColor={colors.blue[400]}
				/>
			)
		}
	}
}

export default CommunicationWindowContainer
